import { FC, useMemo } from 'react';
import Select from '../select';
import { FormProps } from '../helpers';
import { getFormattedUiOptions } from '../select/helpers';
import {
  PublicServiceAction,
  PublicServiceConfig,
  PublicServiceActionOptions,
} from '@/lib/models/policy-model/public-services';

interface Props extends FormProps {
  value: PublicServiceConfig;
  onChange: (value: PublicServiceConfig) => void;
}

const PolicyPublicActionSelect: FC<Props> = ({ value, onChange, ...rest }) => {
  const handleChange = (optValue: string) => {
    const updated = new PublicServiceConfig({
      ...value,
      action: optValue as PublicServiceAction,
      allowPublicServicesByDefault: ['protected', 'monitored'].includes(optValue),
    });

    onChange(updated);
  };

  const serviceOpts = useMemo(() => getFormattedUiOptions(PublicServiceActionOptions), []);

  const { action } = value || {};

  const props = {
    ...rest,
    value: action,
    onChange: handleChange,
    options: serviceOpts,
  };

  return <Select {...props} />;
};

export default PolicyPublicActionSelect;
